import './App.css';
import Homebar from './Components/Homebar'
import MainPage from './Components/OlderStuff/MainPage'
import {Route, Routes} from 'react-router-dom'
import Homepage from './Components/Homepage/Homepage'
function App() {
  return (
    <div>
      <Homebar />
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
      </Routes>

    </div>
  )
}

export default App;
